import { EMAIL_REGEX } from '../constants/generalConstants';
import { NodeEnvTypes } from '../types/generalTypes';

export const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

export const isValidPassword = (password: string) =>
	window._env_.NODE_ENV === NodeEnvTypes.SANDBOX ||
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/.test(password);
